var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReports(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 1h-2a1 1 0 00-1 1v13h4V2a1 1 0 00-1-1zM9 5H7a1 1 0 00-1 1v9h4V6a1 1 0 00-1-1zM3 9H1a1 1 0 00-1 1v5h4v-5a1 1 0 00-1-1z",
    fill: "#797584"
  })));
}

export default SvgReports;